import React from 'react';
import { DetailRequest, RetrieveRequest } from '../../../../utilities/services/RequestService';
import { formatNumber } from '../../../../utilities/actions/Helpers';
import { api } from '../../../../config/Services';
import { Button, InputText, DatePickerBase, Alert } from '../../../../components';
import { Form, Table, Row, Col, Modal, Spin, Dropdown, Menu, Typography, Icon, Button as AntButton, Divider } from 'antd';
import moment from 'moment';
import BulkForm from './Form';
import BulkDetail from './Detail';

const { Column } = Table;
const { Title } = Typography;
const { confirm } = Modal;

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formrender: true,
            dataList: [],
            loading: true,
            visibleTopup: false,
            visibleDetail: false,
            partnercode: this.props.partnercode,
            pagination: {
                current: 1,
                pageSize: 10,
            },
        };
    }

    componentDidMount() {
        document.title = "Manage Bulk Miles Partner | Loyalty Management System";
        setTimeout(() => { this.getList() }, 1500);
        this.setState({ loading: true });
    }

    getList(extraParams = {}) {
        let url = api.url.partnervoucher.partnerbulk.retrievedetail;
        let partnercode = this.props.partnercode;

        let data = { partnercode, ...extraParams };

        DetailRequest(url, data).then((response) => {
            const { status, result } = response;
            if (status.responsecode === '0000' && result) {
                let dataList = result;
                this.setState({ dataList, loading: false });
            } else {
                this.setState({
                    loading: false,
                    responseCode: status.responsecode,
                    responseMessage: status.responsemessage,
                    formrender: false
                });
            }
        });
    }

    handleOpenModal = (type, code1, code2) => {
        if (type === 'topup') {
            this.setState({ visibleTopup: true });
        } else if (type === 'detail') {
            this.setState({ visibleDetail: true, partnerbulkid: code1, partnercode: code2 });
        }
    };

    handleOk = () => {
        this.setState({ visibleTopup: false, visibleDetail: false }, () => this.getList(this.state.partnercode));
    };

    handleCancel = () => {
        this.setState({ visibleTopup: false, visibleDetail: false });
    };

    handleSearch = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            let criteria = {};
            Object.keys(values).forEach(key => {
                if (key === 'createdBy') {
                    criteria[key] = values[key] ? `%${values[key]}%` : null;
                } else {
                    criteria[key] = values[key] !== undefined ? values[key] : null;
                }
            });
            let partnercode = this.state.partnercode;
            let createdBy = criteria.createdBy;
            let transactiondate = criteria.transactiondate ? moment(criteria.transactiondate).format("YYYY-MM-DD") : null;
            this.setState({ data: { partnercode, createdBy, transactiondate } }, () => {
                this.getList({ createdBy, transactiondate });
            });
        });
    };

    handleReset = () => {
        this.props.form.resetFields();
    };

    handleTableChange = (pagination) => {
        this.setState({ pagination });
    }

    handleDownloadModal = (type) => {
        const callback = () => {
            let url = type === "PDF" ? api.url.partnervoucher.partnerbulk.pdf : api.url.partnervoucher.partnerbulk.csv;
            let createdBy = this.props.form.getFieldValue('createdBy');
            let transactiondate = this.props.form.getFieldValue('transactiondate');
            let data = { transactiondate, createdBy, partnercode: this.props.partnercode };
            let partnercode = this.props.partnercode;
            let message = 'Downloading...';
            this.setState({ loading: true });
            Alert.success(message);
            DetailRequest(url, data).then((response) => {
                const { responsecode, responsemessage } = response.status;
                const { result } = response;
                if (responsecode && responsecode === '0000') {
                    window.location.href = result.url;
                    this.setState({ data: { partnercode, createdBy: null, transactiondate: null } }, () => this.getList());
                } else {
                    Alert.error(responsemessage);
                }
                this.setState({ loading: false });
            });
        }

        confirm({
            title: 'Are you sure to download this file?',
            onOk() {
                return new Promise((resolve, reject) => {
                    setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                    callback();
                }).catch(() => console.log('Oops errors!'));
            },
            onCancel() { },
        });
    }

    render() {
        const { dataList, loading, visibleTopup, visibleDetail, partnercode, partnerbulkid } = this.state;
        const formItemStyle = {
            style: {
                marginTop: 0,
                marginBottom: 10
            }
        }

        return (
            <React.Fragment>
                <Row>
                    <Col xs={24} xl={20}>
                        <Title level={4}>Top Up Bulk Miles</Title>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                        <Dropdown overlay={
                            <Menu>
                                <Menu.Item key="1">
                                    <Button htmlType="button" type="default" icon="download" label="PDF" onClick={() => this.handleDownloadModal('PDF')} />
                                </Menu.Item>
                                <Menu.Item key="2">
                                    <Button htmlType="button" type="default" icon="download" label="CSV" onClick={() => this.handleDownloadModal('CSV')} />
                                </Menu.Item>
                            </Menu>
                        }>
                            <AntButton type="default" size="default"> Download <Icon type="down" /></AntButton>
                        </Dropdown>
                    </Col>
                    <Divider />
                </Row>
                <Spin spinning={this.state.loading}>
                    <Modal visible={visibleTopup} title="Topup Bulk Miles Partner" loading={loading} onCancel={this.handleCancel} footer={null} destroyOnClose={true} width={600}>
                        <BulkForm partnercode={partnercode} onClose={this.handleCancel} refreshList={this.handleOk} />
                    </Modal>
                    <Modal visible={visibleDetail} title="Detail Partner Bulk Miles" loading={loading} onCancel={this.handleCancel} footer={null} destroyOnClose={true} width={1200}>
                        <BulkDetail partnercode={partnercode} partnerbulkid={partnerbulkid} onClose={this.handleCancel} />
                    </Modal>
                    <Row style={{ marginBottom: 30 }}>
                        <Form layout="inline" className="searching-form" onSubmit={this.handleSearch}>
                            <DatePickerBase form={this.props.form} placeholder="Transaction Date" datafield="transactiondate" />
                            <InputText form={this.props.form} placeholder="Created By" datafield="createdBy" />
                            <span style={{ lineHeight: '40px' }}>
                                <Button label="Search" size="default" type="primary" htmlType="submit" />
                                <Button label="Clear" size="default" style={{ marginLeft: 8 }} onClick={this.handleReset} htmlType="button" />
                            </span>
                        </Form>
                        <Form {...formItemStyle} loading={loading}>
                            <Row>
                                <Col>
                                    <span className="ant-form-text" style={{ fontWeight: '600' }}>Summary Remaining Award Miles: </span>
                                    <span className="ant-form-text" style={{ marginLeft: 2 }}>{formatNumber((dataList.totalremainingawardmiles ?? 0).toString())}</span>
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Form>
                        <Table
                            rowKey={record => record.partnerbulk}
                            dataSource={dataList.partnerbulk
                                ? [...dataList.partnerbulk].sort((a, b) => {
                                    const t1 = new Date(b.transactiondate) - new Date(a.transactiondate);
                                    if (t1 !== 0) return t1;
                                    return new Date(b.createdDate) - new Date(a.createdDate);
                                })
                                : []}
                            size="middle"
                            pagination={this.state.pagination}
                            scroll={{ y: 490 }}
                            onChange={this.handleTableChange}
                        >
                            <Column
                                title="No"
                                dataIndex="number"
                                key="number"
                                render={(val, row, i) =>
                                    (this.state.pagination.current - 1) * this.state.pagination.pageSize + i + 1
                                }
                                width="10%"
                            />
                            <Column
                                title="Transaction Date"
                                dataIndex="transactiondate"
                                key="transactiondate"
                                render={(val) => val ? moment(val).format('DD/MM/YYYY') : '-'}
                                sorter={(a, b) => {
                                    const t1 = new Date(a.transactiondate) - new Date(b.transactiondate);
                                    if (t1 !== 0) return t1;
                                    return new Date(a.createdDate) - new Date(b.createdDate);
                                }}
                                sortDirections={['descend', 'ascend']}
                                defaultSortOrder="descend"
                            />
                            <Column title="Award Miles" dataIndex="awardmiles" key="awardmiles" align="right" render={(value) => value ? formatNumber(value) : '-'} />
                            <Column title="Remaining Award Miles" dataIndex="remainingawardmiles" key="remainingawardmiles" align='right' render={(value) => value ? formatNumber(value) : '-'} />
                            <Column title="Notes" dataIndex="notes" key="notes" render={(value) => value ? value.length > 20 ? value.substring(0, 20) + '...' : value : '-'} />
                            <Column title="Created By" dataIndex="createdBy" key="createdBy" render={(value) => value ? value : '-'} />
                            <Column
                                title="Action"
                                key="action"
                                width="10%"
                                render={(text, row) => (
                                    <span>
                                        <Button htmlType="button" size="small" label="Detail" className="btn-custom-info" onClick={() => this.handleOpenModal('detail', row.partnerbulkid, row.partnercode)} />
                                    </span>
                                )}
                            />
                        </Table>
                    </Row>
                </Spin>
            </React.Fragment>
        );
    }
}

export default Form.create()(App);